import React, { useEffect, useRef, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";

import ApiService from "../../../../services/api";
import "../../css/login.css";


const ConfirmRegistration = () => {

  const { token } = useParams();
  const navigate = useNavigate();

  const alreadyCalled = useRef(false);

  const [message, setMessage] = useState("");
  const [error, setError] = useState("");


  useEffect(() => {

    if (alreadyCalled.current) return;

    alreadyCalled.current = true;


    const confirmRegistration = async () => {

      try {

        const res = await ApiService.confirmRegistration({
          token
        });


        if (res.success) {

          setMessage(
            "Registrazione completata con successo."
          );


          setTimeout(() => {
            navigate("/login");
          }, 2500);


        } else {

          setError(
            res.message ||
            "Errore durante la conferma della registrazione."
          );

        }


      } catch (err) {

        setError(
          err.response?.data?.message ||
          "Registrazione non trovata o link non valido."
        );

      }

    };


    confirmRegistration();


  }, [token, navigate]);



  return (

    <div className="login-container">

      <div className="login-flex-wrapper">

        <h1 className="login-title">
          Conferma registrazione
        </h1>


        <div className="login-form-box">


          {message && (

            <div style={{ textAlign: "center" }}>

              <h3>
                Registrazione completata
              </h3>

              <p style={{color: '#393939'}}>
                {message}
              </p>

              <p>
                Verrai reindirizzato al login...
              </p>

            </div>

          )}



          {error && (

            <div style={{ textAlign: "center" }}>

              <h3>
                Errore
              </h3>

              <p className="error">
                {error}
              </p>


              <button
                className="btn-login"
                onClick={() => navigate("/login")}
              >
                Torna al login
              </button>

            </div>

          )}



          {!message && !error && (

            <div style={{ textAlign: "center" }}>

              <p>
                Conferma registrazione in corso...
              </p>

            </div>

          )}


        </div>


      </div>

    </div>

  );

};


export default ConfirmRegistration;